import { Card } from '@aws-amplify/ui-react';
import type { Edulead } from 'edulead';
import { useContext, useEffect, useState } from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';
import LoadingBars from '../custom-components/LoadingBars';
import NA from '../custom-components/NA';
import { GlobalContext } from '../global-context';
import { allPages, toastV4Error } from '../services/edulead-v4';
import { eduleadV4 } from '../services/edulead-v4-client';
import General from '../utils/GeneralUtils';
import './Billing.scss';

export function Billing() {

  const globalContext = useContext(GlobalContext);
  General.setTitle(document, 'Billing', globalContext);

  const [receipts, setReceipts] = useState<Edulead.EduleadV4Receipt[]>();
  const [isLoadingReceipts, setIsLoadingReceipts] = useState(false);

  useEffect(() => {
    if (globalContext?.authInfo?.teamId) {
      loadReceipts()
    }
  }, [globalContext.authInfo?.teamId])

  async function loadReceipts() {
    try {
      setIsLoadingReceipts(true)
      setReceipts(await allPages(eduleadV4.receipts.list({ page_size: 100 })))
    } catch (err) {
      toastV4Error(err, 'Something went wrong while fetching receipts')
    } finally {
      setIsLoadingReceipts(false)
    }
  }

  return <GlobalContext.Consumer>
    {
      () => <>
        <div className="content content-1000">
          <h2>Billing History{!!receipts?.length && <> ({receipts?.length})</>}</h2>
          
          <Card variation='outlined' style={{fontSize: 14, marginTop: 20}}>
            {
              !isLoadingReceipts
                ? receipts?.length
                  ? <div>
                    <table className='billing-table'>
                      <thead>
                        <tr>
                          <td className='desc-8'>Date</td>
                          <td className='desc-8'>Amount</td>
                          <td className='desc-8'>Status</td>
                          <td></td>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          receipts.map((receipt, index) => {
                            return <tr key={index}>
                              <td>{General.epochToHumanReadableDate2(receipt.create_time)}</td>
                              <td>${Math.round(Number(receipt.amount ?? 0) / 100)}.00</td>
                              <td>{General.capitalizeFirstLetter(receipt.status ?? '')}</td>
                              <td className='receipt-link'>
                                <a href={receipt.receipt_url} target='_blank'>Receipt <FaExternalLinkAlt className='external-link-icon' /></a>
                              </td>
                            </tr>
                          })
                        }
                      </tbody>
                    </table>
                  </div>
                  : <NA text='No receipts found' />
                : <LoadingBars numberOfRows={3} />
            }
          </Card>
        </div>
      </>
    }
  </GlobalContext.Consumer>
}
